var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsappBusinessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "white",
    viewBox: "0 0 32 32",
    id: "whatsapp-business",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 4C10.383 4 5 9.383 5 16c0 2.003.503 3.974 1.473 5.754l-2.33 5.827a.999.999 0 0 0 1.3 1.299l5.837-2.335A11.948 11.948 0 0 0 17 28c6.617 0 12-5.383 12-12S23.617 4 17 4zm0 22a9.962 9.962 0 0 1-5.135-1.423.998.998 0 0 0-.906-.063l-4.094 1.644 1.522-3.808.109-.241a1.004 1.004 0 0 0-.009-.844 2.041 2.041 0 0 0-.103-.19A9.995 9.995 0 0 1 7 16c0-5.514 4.486-10 10-10s10 4.486 10 10-4.486 10-10 10zm4.664-12.811C21.509 11.401 19.898 10 18 10h-4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h4c1.898 0 3.509-1.401 3.664-3.189a3.516 3.516 0 0 0-1.037-2.81 3.522 3.522 0 0 0 1.037-2.812zM18 20h-3v-3h3.178c.426 0 .818.173 1.106.487.287.313.425.722.388 1.15C19.606 19.389 18.856 20 18 20zm1.284-5.487c-.288.314-.68.487-1.106.487H15v-3h3c.856 0 1.606.611 1.672 1.363.037.428-.101.837-.388 1.15z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappBusinessIcon);
export default __webpack_public_path__ + "static/media/whatsapp-business-icon.69ec70af669dbbe4b6865a6d476c0b04.svg";
export { ForwardRef as ReactComponent };